import { render } from "./Vacuna_VacunaPers.vue?vue&type=template&id=e3ee6d7e"
import script from "./Vacuna_VacunaPers.vue?vue&type=script&lang=js"
export * from "./Vacuna_VacunaPers.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__